{
  "titles": {
    "menu": "Spaarcontracten",
    "table": "Contracten",
    "create": "Contract aanmaken",
    "update": "Contract wijzigen",
    "payments": "Uitbetalingen",
    "finalPayment": "Eindafrekening",
    "funder": "Spaarder",
    "fundingContract": "Spaarcontract",
    "account": "Account",
    "contractInformation": "Contractinformatie",
    "files": "Documenten",
    "updateIban": "Rekeningnummer aanpassen",
    "revertRenewalNotPossible": "Terugdraaien niet mogelijk",
    "dissolveNotPossible": "Ontbinden niet mogelijk",
    "cancelContract": "Contract annuleren",
    "deleteContract": "Contract verwijderen",
    "receivedDeposit": "Ontvangen gelden",
    "receivedTopUp": "Ontvangen bijstorting",
    "cancelReason": "Reden van annulering",
    "dissolveReason": "Reden van ontbinding"
  },
  "errors": {
    "titles": {
      "404": "Contract niet gevonden"
    },
    "messages": {
      "404": "Dit spaarcontract bestaat niet (meer)."
    }
  },
  "fields": {
    "labels": {
      "funderId": "Spaarder",
      "referenceNumber": "Contractnummer",
      "startDate": "Startdatum",
      "endDate": "Einddatum",
      "variant": "Variant",
      "amount": "Inleg",
      "interestRate": "Rente",
      "durationInMonths": "Looptijd",
      "period": "Contractperiode",
      "interestPeriod": "Renteperiode",
      "funderName": "Spaarder",
      "interestCurrentMonth": "Rente {month}",
      "monthlyInterest": "Maandrente",
      "iban": "IBAN",
      "bic": "BIC",
      "beneficiaryName": "Naam rekeninghouder",
      "depositDate": "Datum gelden ontvangen",
      "isNameCorrect": "Naam rekeninghouder correct",
      "expirationReason": "Reden",
      "expirationExplanation": "Toelichting",
      "declinedReason": "Reden",
      "declinedExplanation": "Toelichting",
      "cancelReason": "Reden",
      "cancelExplanation": "Toelichting",
      "dissolveReason": "Reden",
      "dissolveExplanation": "Toelichting",
      "reimbursementDate": "Datum terugbetaling",
      "topUp": "Bijstorting",
      "fileContract": "Getekend contract incl verklaring herkomst gelden",
      "contractFileId": "Getekend contract",
      "declarationOfSourceOfFundsFileId": "Getekende verklaring herkomst middelen",
      "reimbursementAmount": "Terug te betalen bedrag",
      "description": "Omschrijving",
      "renewalOption": "Verlengingsoptie",
      "deviations": {
        "interestRate": {
          "value": "Afwijkende rente",
          "explanation": "Toelichting"
        },
        "durationInMonths": {
          "value": "Afwijkende looptijd",
          "explanation": "Toelichting"
        }
      },
      "previousContract": "Voorgaand contract",
      "ibanChecked": "Ik heb gecontroleerd dat het nieuwe rekeningnummer bij deze spaarder hoort d.m.v. een overboeking"
    },
    "hints": {
      "depositDate": "Rente vanaf {date}"
    },
    "validationErrors": {
      "startDate": {
        "minDate": "{0} moet in de toekomst liggen"
      },
      "depositDate": {
        "before": "{0} mag niet in de toekomst liggen en moet voor de einddatum van het contract zijn"
      }
    }
  },
  "headers": {
    "labels": {
      "interestCurrentMonth": "Rente {month}",
      "interestRate": "Rente percentage",
      "status": "Status"
    }
  },
  "messages": {
    "tacitlyRenewed": "Stilzwijgend verlengd",
    "createSuccess": "Contract aangemaakt",
    "updateSuccess": "Contract is opgeslagen",
    "rateAndInterest": "{percentage} ({monthlyInterest} per maand)",
    "rateNotAvailable": "Vul velden in om de rente te berekenen",
    "expiringSoon": "Dit contract verloopt binnenkort",
    "noPayments": "Er is nog geen uitbetaling gedaan",
    "statusFunderFieldsMissing": "De volgende velden van de spaarder zijn niet (juist) ingevuld:",
    "statusFundingContractFieldsMissing": "De volgende velden van het spaarcontract zijn niet (juist) ingevuld:",
    "statusAccountFieldsMissing": "De volgende velden van een van de accounts is niet (juist) ingevuld:",
    "contractStatusInProgress": "in behandeling",
    "deviateInterest": "Afwijkende rente aanvragen",
    "deviatedInterest": "Er wordt afgeweken van de rente zodra u opslaat",
    "deviationPending": "Afwijkende aanvraag in behandeling",
    "deviationApproved": "Afwijkende aanvraag goedgekeurd",
    "deviationNotADeviation": "De afwijking, is niet daadwerkelijk een afwijking",
    "deviateDuration": "Afwijkende looptijd aanvragen",
    "deviatedDuration": "Afwijkende looptijd wordt aangevraagd",
    "deviateReject": "Voorgestelde rente afwijzen",
    "cantSend": "Er missen gegevens om dit contract te kunnen versturen. D.m.v. de onderstaande knoppen wordt je naar de formulieren geleid waar je de ontbrekende gegevens kunt invullen.",
    "accountIdentityIncorrect": "De identiteit van {name} is niet gevalideerd",
    "dissolvingRenewedContractWarning": "Dit contract betreft een verlenging. Het voorgaande contract wordt met deze actie beëindigd met 'geen verlenging'",
    "uploadSignedContract": "Upload het getekende contract",
    "uploadDeclarationOfSourceOfFunds": "Upload de verklaring herkomst middelen",
    "uploadContractStep": "Contract uploaden",
    "uploadDeclarationStep": "Verklaring herkomst uploaden",
    "alerts": {
      "newContract": "De gelden zijn binnen en het contract zal automatisch op {startDateInterest} rentedragend worden.",
      "renewAndTopUp": "Dit contract is een verlenging van een voorgaand contract. De bijstorting is binnen en het contract zal automatisch op {startDateInterest} rentedragend worden.",
      "renewal": "Dit contract is een verlenging van een voorgaand contract. De gelden zijn al binnen en het contract zal automatisch op {startDateInterest} rentedragend worden.",
      "isDissolved": "Dit contract is ontbonden",
      "isCanceled": "Dit contract is geannuleerd en is niet actief geweest.",
      "confirmRevert": "Weet je zeker dat je de verlenging van dit contract wil terugdraaien?",
      "revertRenewalFullyReimbursed": "De verlenging kan niet worden teruggedraaid, omdat het volledige bedrag van het contract al is terugbetaald.",
      "dissolveFullyReimbursed": "Het contract kan niet worden ontbonden, omdat het volledige bedrag van het contract al is terugbetaald.",
      "fundsReceivedQuestion": "Zijn er al gelden ontvangen van de spaarder?",
      "topUpReceivedQuestion": "Zijn er al extra gelden (bijstorting) ontvangen voor de verlenging?",
      "topUpForRenewal": "Het gaat om de extra gelden die voor de verlenging zijn ontvangen, niet om de inleg van dit lopende contract.",
      "confirmDelete": "Weet je zeker dat je dit conceptcontract wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "cannotDeleteFundsReceived": "Er zijn gelden ontvangen, het contract wordt geannuleerd en er wordt een taak voor terugstorting aangemaakt.",
      "cannotDeleteAnymore": "Dit contract kan niet meer worden verwijderd, omdat het inmiddels is gewijzigd of verzonden. Annuleer het contract in plaats daarvan.",
      "revertRenewalNotSupported": "Deze verlenging kan niet worden teruggedraaid vanwege de status van het nieuwe contract.",
      "cancelRenewalWarning": "Dit contract is een verlenging. Het voorgaande contract wordt teruggehaald.",
      "contractDeleted": "Contract verwijderd",
      "contractCanceled": "Contract geannuleerd",
      "contractDissolved": "Contract ontbonden"
    },
    "ibanChangeSuccess": "IBAN is succesvol gewijzigd."
  },
  "actions": {
    "create": "Contract aanmaken",
    "update": "Contract aanpassen",
    "search": "Zoek een spaarcontract",
    "statusChange": "Status wijzigen",
    "DraftToSentDigital": "Digitaal verzenden",
    "DraftToSentManually": "Handmatig verzenden",
    "SentManuallyToSignedByFunder": "Contract getekend",
    "SentManuallyToDraft": "Contract opnieuw bewerken",
    "SentManuallyToCanceled": "Contract annuleren",
    "SentDigitalToDraft": "Contract opnieuw bewerken",
    "SentDigitalToCanceled": "Contract annuleren",
    "SignedByFunderToValidated": "Contract controleren",
    "SignedByFunderToInactive": "Contract ontbinden",
    "ActiveToInactive": "Contract ontbinden",
    "renew": "Contract verlengen",
    "expire": "Niet verlengen",
    "export": "Exporteren",
    "scheduled": "Ingepland",
    "validate": "Accorderen",
    "reset": "Herstelverzoek",
    "revertRenewal": "Verlenging terugdraaien",
    "updateIban": "Rekeningnummer aanpassen",
    "updateDeclaration": "Verklaring herkomst middelen",
    "cancelContract": "Contract annuleren",
    "deleteContract": "Contract verwijderen",
    "dissolveContract": "Contract ontbinden",
    "moreActions": "Meer acties",
    "cancel": "Annuleren",
    "fundsReceivedYes": "Ja, gelden ontvangen",
    "fundsReceivedNo": "Nee, geen gelden ontvangen"
  },
  "validations": {
    "isPartialAmount": {
      "yes": "Ja",
      "no": "Nee"
    },
    "titles": {
      "reset": "Herstelverzoek"
    },
    "fields": {
      "labels": {
        "expectedDepositAmount": "Verwachte totale storting",
        "deposits": "Stortingen",
        "iban": "IBAN",
        "amount": "Ontvangen bedrag",
        "date": "Datum",
        "name": "Naam rekeninghouder",
        "funderDisplayName": "Spaarder naam",
        "hasMatchingAccountName": "Naam rekeninghouder correspondeert met spaarder naam",
        "isBeneficiary": "Rente ontvangen op deze IBAN",
        "isBeneficiaryOverride": "Rente ontvangen op deze IBAN in plaats van op de voorgaande storting",
        "bic": "BIC",
        "isPartialAmount": "Is de inleg volledig ontvangen?",
        "beneficiaryIban": "Rente wordt overgemaakt op",
        "isSourceDeclared": "Er is {amount} verklaard",
        "isFundingDeclared": "Herkomst van gelden is akkoord",
        "declaredAmountNotMatching": "Het verklaarde bedrag komt niet overeen met de inleg",
        "noDeclaredAmount": "Er is geen bedrag ingevuld",
        "sourceUnclear": "De herkomst van gelden is onvoldoende toegelicht",
        "nameNotMatching": "De naam {name} komt niet volledig overeen met de naam uit de identiteitscontrole",
        "identityNotMatching": "De naam {name} komt niet overeen met de naam uit de identiteitscontrole",
        "dateOfBirthNotMatching": "De geboortedatum van {name} komt niet overeen met de geboortedatum uit de identiteitscontrole",
        "identityDeclineReasons": "Minimaal 1 reden selecteren",
        "declarationOfFundsDeclineReasons": "Minimaal 1 reden selecteren"
      },
      "hints": {
        "date": "Vul hier de datum in wanneer de gelden op de bank zijn ontvangen",
        "amount": "Vul hier het bedrag in dat op de bank is ontvangen",
        "name": "Vul de naam in die correspondeert met de IBAN hierboven"
      }
    },
    "errors": {
      "validation": {
        "beneficiaryDeposit": "Dit is de laatste of enige betaling en moet daarom rente ontvangen.",
        "depositAmount": "Het bedrag moet gelijk zijn aan het verwachte stortingsbedrag, of lager bij een deelbetaling."
      }
    },
    "actions": {
      "addDeposit": "Storting toevoegen",
      "cancel": "Annuleren",
      "send": "Versturen"
    },
    "steps": {
      "deposit": "Gelden ontvangen",
      "summary": "Samenvatting",
      "declarationOfFunds": "Herkomst",
      "identity": "Identiteit"
    },
    "messages": {
      "declarationOfFundsSuccess": "Verklaring herkomst middelen is opgeslagen",
      "depositSuccess": "Storting toegevoegd",
      "noDepositRequired": "Voor dit contract is geen storting vereist, de gelden zijn al binnen.",
      "beneficiaryAlreadySet": "Deze IBAN staat al gemarkeerd als rente ontvangende IBAN",
      "depositStatus": {
        "invalid": "De inleg is nog niet gestort",
        "pending": "Er is {depositedAmount} van de {expectedDepositAmount} ontvangen"
      },
      "depositStatusCompleted": {
        "renewAndTopUp": "De bijstorting van {expectedDepositAmount} is gestort. Het contract ontvangt rente vanaf {fundingContractStartDate}",
        "renew": "Het betreft een volledige verlenging. De gelden zijn al gestort. Het contract ontvangt rente vanaf {fundingContractStartDate}",
        "partiallyRenew": "Het betreft een gedeeltelijke verlenging. De gelden zijn al gestort. Het contract ontvangt rente vanaf {fundingContractStartDate}",
        "default": "De totale inleg van {expectedDepositAmount} is gestort. Het contract ontvangt rente vanaf {fundingContractStartDate}"
      },
      "depositNameCheckStatus": {
        "invalid": "Naam rekeninghouder niet akkoord",
        "pending": "Naam rekeninghouder deels akkoord",
        "completed": "Naam rekeninghouder akkoord"
      },
      "declarationOfFundStatus": {
        "Invalid": "Verklaring herkomst middelen niet akkoord",
        "Completed": "Verklaring herkomst middelen akkoord"
      },
      "identityValidationStatus": {
        "Invalid": "Identiteit tekenbevoegden niet akkoord",
        "Pending": "Identiteit tekenbevoegden deels akkoord",
        "Completed": "Identiteit tekenbevoegden akkoord"
      },
      "noDeclarationFunds": "Voor dit contract is geen verklaring herkomst middelen vereist, daarom is deze stap reeds akkoord.",
      "reset": {
        "notifyReidentification": "Je gaat alle tekenbevoegden het contract {withDeclaration}opnieuw versturen. De tekenbevoegden moeten zich opnieuw identificeren. Kies uit onderstaande reden(en).",
        "withDeclaration": "met verklaring herkomst middelen ",
        "canStillEdit": "Het contract of de spaardergegevens kunnen nog bewerkt worden voor versturing.",
        "notifyFunder": "Je kunt contact opnemen met de spaarder om deze te informeren."
      },
      "contractResetReason": "Waarom moet het contract opnieuw getekend worden?",
      "declarationOfFunds": "Verklaring herkomst middelen",
      "identity": "Identiteitscontrole",
      "resetSuccess": "Het herstelverzoek is verstuurd",
      "noDeposits": "Er zijn nog geen stortingen gedaan"
    },
    "tooltips": {
      "hasMatchingAccountName": "Controleer of de gelden gestort zijn door de spaarder en niet door iemand anders. Dit moet voor iedere storting gedaan worden."
    }
  },
  "declarationOfSourceOfFunds": {
    "titles": {
      "declarationOfSourceOfFunds": "Verklaring herkomst middelen",
      "addSource": "Herkomst toevoegen",
      "totalDeclared": "Totaal verklaard"
    },
    "explanation": "Beschrijf kort waar de middelen vandaan komen, bijvoorbeeld uit winst uit onderneming of uit een schenking. Deze informatie wordt verwerkt in de Verklaring Herkomst Middelen die ter ondertekening wordt aangeboden.",
    "fields": {
      "labels": {
        "type": "Type herkomst",
        "amount": "Bedrag",
        "depositAmount": "Inleg bedrag",
        "companyName": "Bedrijfsnaam",
        "borrowedFrom": "Geleend bij",
        "relationToLender": "Relatie met geldverstrekker",
        "hasAgreement": "Is er een leningsovereenkomst?",
        "hasAgreementYes": "Ja",
        "hasAgreementNo": "Nee",
        "fileId": "Leningsovereenkomst toevoegen",
        "donatedBy": "Schenking door",
        "relationToDonor": "Relatie met schenker",
        "explanation": "Toelichting"
      },
      "hints": {
        "amount": "Vul hier het bedrag in dat verklaard wordt",
        "companyName": "Vul hier de naam van het bedrijf in",
        "borrowedFrom": "Vul hier de naam van de geldverstrekker in",
        "relationToLender": "Vul hier de relatie met de geldverstrekker in bijvoorbeeld: 'vader'",
        "donatedBy": "Vul hier de naam van de schenker in",
        "relationToDonor": "Vul hier de relatie met de schenker in"
      }
    },
    "enums": {
      "fundSourceType": {
        "Turnover": "Winst uit onderneming",
        "Loan": "Geleend bij",
        "Donation": "Schenking door",
        "Other": "Anders, namelijk"
      }
    },
    "actions": {
      "addSource": "Herkomst toevoegen",
      "update": "Verklaring opslaan"
    },
    "messages": {
      "amountOverDeclared": "Er is {amount} te veel verklaard",
      "percentDeclared": "{percent}% verklaard",
      "remainingToGo": "Nog {amount} te gaan",
      "updateSuccess": "Verklaring herkomst middelen is opgeslagen"
    }
  }
}
